import {Component} from '@angular/core';
import {environment} from "../../environments/environment";
import {AuthService} from "../_services/auth.service";
import {BreadcrumbService} from "xng-breadcrumb";

@Component({
  standalone: false,
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent {

  form: any = {};
  isSuccessful = false;
  isSignedUpFailed = false;
  errorMessage = '';
  url = '';

  constructor(private signUpService: AuthService,
              private breadcrumbService: BreadcrumbService) {
    environment.then(environment => {
      this.url = environment["backendURL"];
    });
  }

  onSubmit(): void {
    this.breadcrumbService.set('@Sign-Up', 'Sign Up');
    this.signUpService.register(this.url, this.form).subscribe(
      data => {
        // console.log(data);
        this.isSuccessful = true;
        this.isSignedUpFailed = false;
      },
      err => {
        this.errorMessage = err.error.message;
        this.isSignedUpFailed = true;
      }
    );
  }

}
